import React, { useState } from 'react';
import { 
  Container, Row, Col, InputGroup, InputGroupAddon, InputGroupText, 
  Input, FormGroup, Button, Label, Form, FormFeedback
 } from 'reactstrap';
import logoImg from '../../assets/images/forgot.png';
import Background from '../../assets/images/paygovbackground.jpg';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SEND_OTP } from '../../utils/APIEndpoints';
import { authHeader } from '../../utils/functions/CoreFunctions';
import API from '../../redux/actions/API';
import { getAlertToast } from '../../utils/functions/CustomFunctions';
import UpdatePassword from './UpdatePassword';
import Swal from 'sweetalert2';
import CustomLoader from '../common/CustomLoader';
import { SIGNIN_PATH } from '../../utils/AppRoutes';
import { Link } from 'react-router-dom';

const validationSchema = Yup.object({
  email: Yup.string().required('Email is required').email('Enter valid email'),
});

 
const ForgotPassword = (props) => {

    const [loading,setLoading] = useState(false);
    const [isOtpSuccess, setIsOtpSuccess] = useState(false);

    const { handleSubmit, handleChange, values, errors,touched,setFieldTouched } = useFormik({
        initialValues: {
          email: ''
        },
        validationSchema,
        onSubmit(values) {
            getOTP(values);  
        }
      });

    const getOTP = async (values) => {
      try{
        setLoading(true);
        const options = {
            method : 'GET',
            url : SEND_OTP,
            headers : authHeader(),
            params : values
        };
        const response = await API(options);
        const {status,message} = response.data;
        if(status === 'Success')
        {
          Swal.fire(getAlertToast('success', 'OTP successfully sent to your email account')); 
          setIsOtpSuccess(true);
        }else{
          Swal.fire(getAlertToast('error', message));
        }
        }catch(error){
            if (error.response) {
            let { data } = error.response;
            Swal.fire(getAlertToast('error', data.message)); 
            }
        }finally{
            setLoading(false);
        }
    }

    return (
        <div className='loginbg' style={{backgroundImage: `url(${Background})`}}>
        <Container>
        <Row>
        <Col sm='12' md={{ size: 8, offset: 2 }}>
        <Row>
            <Col xs='6' className='loginbg-color'>
              <img src={logoImg} className='w-100' />
            </Col>
            { !isOtpSuccess && 
            <Col xs='6' className='bg-white p-4 pt-5 pb-5'>
            <h5 className='mb-4'>Find Your Account</h5>
            <Form onSubmit={handleSubmit}>
                <FormGroup>
                    <Label for="email">Email</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                          <InputGroupText><i className='far fa-envelope'/></InputGroupText>
                      </InputGroupAddon>
                        <Input type="email" name="email" id="email" placeholder="Enter Email"
                      invalid={(errors.email && touched.email) ? true : false} 
                      onChange={(event) => {
                          setFieldTouched('email',true);
                          handleChange(event);
                      }} 
                      value={values.email} />
                    <FormFeedback>{(errors.email && touched.email) ? errors.email : ''}</FormFeedback>
                    </InputGroup>
                </FormGroup> 
                <div className='mt-5'>
               <Link to={SIGNIN_PATH}> <Button color='primary' type='button'>
                  Login  
              </Button></Link>
              <Button className='f-r' color='primary' type='submit' disabled={loading}>
                {loading && <CustomLoader loading={loading}/>}{' '} Send OTP
              </Button>
              </div>
            </Form>
            </Col>
            }
            { isOtpSuccess && 
            <UpdatePassword email={values.email}/>
            }
        </Row>
        </Col>
        </Row>
        </Container>
        </div>
    );
}

export default ForgotPassword;
